import { useCallback, useState } from 'react'
import {
  fetchAllDataHome,
  fetchProcessById,
} from 'views/screens/Platform-administrator/Home/services/fetch-home-data-platform-admin'
import { IDataprocessInfo } from 'types/common'
import { useNotification } from 'lib/context/notification.context'
import getTestsForCompany from 'services/companies/getTestsOnDraftProcesses/getTestsOnDraftProcesses'

interface TestPercentages {
  betesaPercent: number
  skillPercent: number
}

interface ITestByCompany {
  draftTests: number
  sentTests: number
  totalTests: number
  categories: { Betesa: number; Skills: number; Test360: number }
}

export const useGetResumeProcess = () => {
  const { getError } = useNotification()

  const [loadingDetailProcess, setLoadingDetailProcess] = useState<boolean>(false)
  const [processInfo, setProcessInfo] = useState<IDataprocessInfo | null>(null)
  const [testPercentages, setTestPercentages] = useState<TestPercentages>({
    betesaPercent: 0,
    skillPercent: 0,
  })
  const [testsByCompany, setTestsByCompany] = useState<ITestByCompany>()

  const fetchProcessData = useCallback(async (selectedProcess: any | '') => {
    setLoadingDetailProcess(true)
    try {
      const response: IDataprocessInfo = !Array.isArray(selectedProcess)
        ? await fetchProcessById(selectedProcess)
        : await fetchAllDataHome()
      if (response && response.status === 'OK') {
        setProcessInfo(response)
        setTestPercentages({
          betesaPercent:
            typeof response.total_tests_generated?.betesaPercent === 'number'
              ? parseFloat(response?.total_tests_generated?.betesaPercent.toFixed(2))
              : 0,
          skillPercent:
            typeof response.total_tests_generated?.skillPercent === 'number'
              ? parseFloat(response?.total_tests_generated?.skillPercent.toFixed(2))
              : 0,
        })
      } else {
        getError('Error al obtener los datos del proceso seleccionado')
        throw new Error()
      }
    } finally {
      setLoadingDetailProcess(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchTestsByCompany = useCallback(async (selectedProcess: any | '') => {
    try {
      const response = selectedProcess ? await getTestsForCompany(selectedProcess) : await getTestsForCompany()
      if (response.status === 'OK') {
        setTestsByCompany(response.data.testCount)
      } else {
        getError('Error al obtener los datos de los tests en borrador')
      }
    } catch (error) {
      getError('Error al obtener los datos de los tests en borrador')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { loadingDetailProcess, processInfo, testPercentages, fetchProcessData, fetchTestsByCompany, testsByCompany }
}
